import { Button } from '../../atoms'
import { buttonsContainer, container, submitButton } from './index.css'

export const ModalInfo = (props: {
  text: string
  buttonText?: string
  onClose: () => void
}) => {
  return (
    <div className={container}>
      <span>{props.text}</span>
      <div className={buttonsContainer}>
        <Button
          onClick={props.onClose}
          variant='primary'
          analytic={{
            name: 'ok',
            params: {
              modal: 'info',
            },
          }}
          className={submitButton}
        >
          {props.buttonText || 'OK'}
        </Button>
      </div>
    </div>
  )
}
